<template>
  <div class="flex h-screen bg-white font-roboto">
    <!-- Sidebar -->
    <div :class="['transition-all duration-300', isSidebarShrunk ? 'w-16' : 'w-72']"
      class="relative bg-custom-blue text-white">
      <div class="flex items-center justify-between px-6 py-3">
        <div v-if="!isSidebarShrunk" class="flex items-center">
          <img class="object-cover w-18 h-10" src="@/assets/images/Jiji-Health-White-Logo.png" alt="Your avatar" />
        </div>
        <div>
          <button @click="toggleSidebar" class="text-white focus:outline-none">
            <svg class="w-6 h-6 text-gray-100 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h14" />
            </svg>
          </button>
        </div>
      </div>

      <nav>
        <!-- Loop through sidebarTabs -->
        <div v-for="tab in filteredSidebarTabs" :key="tab.name">
          <router-link v-if="!tab.children" :to="tab.route"
            :class="[isActive(tab) ? activeClass : '', 'flex items-center px-4 py-3 m-2 duration-200 text-white rounded-md']">
            <div v-html="tab.icon" class="w-6 h-6"></div>
            <!-- Conditionally show the name based on sidebar state -->
            <span v-if="!isSidebarShrunk" class="ml-4">{{ tab.name }}</span>
          </router-link>

          <!-- Dropdown tabs -->
          <div v-else>
            <div class="flex items-center px-4 py-3 m-2 duration-200 text-white rounded-md cursor-pointer"
              @click="toggleDropdown(tab)">
              <div v-html="tab.icon" class="w-6 h-6"></div>
              <span v-if="!isSidebarShrunk" class="ml-4">{{ tab.name }}</span>
            </div>
            <div v-if="isDropdownOpen(tab)" :class="[isSidebarShrunk ? 'ml-0' : 'ml-8']">
              <router-link v-for="child in tab.children" :key="child.name" :to="child.route"
                :class="[isActive(child) ? activeClass : '', 'flex items-center px-4 py-2 m-2 duration-200 text-white rounded-md']">
                <div v-html="child.icon" class="w-5 h-5"></div>
                <span v-if="!isSidebarShrunk" class="ml-4">{{ child.name }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!-- Main content -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header />
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-white">
        <div class="mx-auto px-6 py-2">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import sidebarTabs from '@/config/sidebar';
import Header from "./HeaderLayout.vue";

export default {
  name: 'SidebarLayout',
  components: {
    Header
  },
  data() {
    return {
      sidebarTabs,
      activeClass: 'bg-custom-yellow',
      openDropdown: null,
      isSidebarShrunk: false,
      userType: null,
    };
  },
  created() {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      this.userType = user?.UserType || null;
    } catch { console.log('created') }
  },
  computed: {
    filteredSidebarTabs() {
      return this.sidebarTabs.filter(tab => {
        if (tab.allowedRoles && !tab.allowedRoles.includes(this.userType)) return false;
        if (this.userType === 'Nurse' && tab.name === 'Patients') return false;
        return true;
      });
    },
  },
  mounted() {
    this.getUserType();
  },
  methods: {
    toggleSidebar() {
      this.isSidebarShrunk = !this.isSidebarShrunk;
    },
    isActive(tab) {
      return this.$route.path === tab.route;
    },
    toggleDropdown(tab) {
      this.openDropdown = this.openDropdown === tab ? null : tab;
    },
    isDropdownOpen(tab) {
      return this.openDropdown === tab;
    },
    getUserType() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.UserType) {
        this.userType = user.UserType;
      }
    }
  }
}
</script>

